(function(){
function bcInit(){
  var form=document.getElementById('bc-product-form');
  if(form){
    var ret=form.querySelector('[data-bc-return]');
    var cartBtn=form.querySelector('[data-bc-cart]');
    if(cartBtn){cartBtn.addEventListener('click',function(){ if(ret) ret.value='/cart'; });}
    var buyBtn=form.querySelector('[data-bc-buy]');
    if(buyBtn){buyBtn.addEventListener('click',function(){ if(ret) ret.value='/checkout'; });}
  }
  document.querySelectorAll('[data-bc-open]').forEach(function(a){
    a.addEventListener('click',function(){var d=document.getElementById(a.dataset.bcOpen); if(d){d.open=true;}});
  });
  var nav=document.getElementById('bc-snav'); if(!nav) return;
  var fb=nav.querySelector('[data-bc-float-buy]');
  if(fb&&form){fb.addEventListener('click',function(){ var b=form.querySelector('[data-bc-buy]'); if(b) b.click(); });}
  var links=nav.querySelector('[data-bc-links]');
  var secs=[].slice.call(document.querySelectorAll('[data-bc-nav]')).filter(function(s){return s.dataset.bcNav && s.dataset.bcNav.trim()!=='';});
  secs.forEach(function(s,i){
    if(!s.id) s.id='bc-s-'+i;
    s.style.scrollMarginTop='90px';
    var a=document.createElement('a'); a.href='#'+s.id; a.textContent=s.dataset.bcNav;
    a.addEventListener('click',function(e){e.preventDefault(); s.scrollIntoView({behavior:'smooth',block:'start'});});
    links.appendChild(a);
  });
  var buy=document.getElementById('bc-buy'); var last; var ticking=false;
  function update(){
    ticking=false;
    var show = buy ? buy.getBoundingClientRect().bottom < 0 : false;
    nav.classList.toggle('is-on', show);
    var cur=null; secs.forEach(function(s){ if(s.getBoundingClientRect().top < window.innerHeight*0.4) cur=s; });
    if(cur===last) return; last=cur;
    [].forEach.call(links.children,function(a){
      var on = cur && a.getAttribute('href')==='#'+cur.id;
      a.classList.toggle('is-active', !!on);
      if(on){ links.scrollTo({left: a.offsetLeft - links.clientWidth/2 + a.clientWidth/2, behavior:'smooth'}); }
    });
  }
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } }
  document.addEventListener('scroll',onScroll,{passive:true,capture:true});
  window.addEventListener('resize',onScroll);
  update();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bcInit);}else{bcInit();}
})();
